function browser_name() {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();

	if (userAgent.indexOf("msie") > -1) {
		if (appVersion.indexOf("msie 6.0") > -1) {
			//alert("IE6");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 7.0") > -1) {
			//alert("IE7");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 8.0") > -1) {
			//alert("IE8");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 9.0") > -1) {
			//alert("IE9");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 10.0") > -1) {
			//alert("IE10");
		} else {
			//alert("Unknown");
		}
	} else if (userAgent.indexOf("trident/7.0") > -1) {
		//alert("IE11");
		$('html').addClass('isIE');
	} else if (userAgent.indexOf("edge") > -1) {
		//alert("Edge");
		$('html').addClass('isEdge');
	} else if (userAgent.indexOf("firefox") > -1) {
		//alert("Firefox");
	} else if (userAgent.indexOf("opera") > -1) {
		//alert("Opera");
	} else if (userAgent.indexOf("chrome") > -1) {
		//alert("Google Chrome");
	} else if (userAgent.indexOf("safari") > -1) {
		//alert("Safari");
	} else {
		//alert("Unknown");
	}
}


browser_name();


// PC / SP判定
if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
	// スマホ時に行う処理を書く
} else {
	// PC・タブレット時に行う処理を書く
}

// 画面サイズ判定
var windowWidth = $(window).width();
var windowsm = 640;
if (windowWidth <= windowsm) {
	//横幅640px以下のとき（つまりスマホ時）に行う処理を書く
} else {
	//横幅640px超のとき（タブレット、PC）に行う処理を書く
}

// iOSのバージョン判断
function ios_ver() {
	var ios_ua = navigator.userAgent;
	if (ios_ua.indexOf("iPhone") > 0) {
		ios_ua.match(/iPhone OS (\w+){1,3}/g);
		var version = (RegExp.$1.replace(/_/g, '') + '00').slice(0, 3);
		return version;
	}
}

// Androidのバージョン判断
function and_ver() {
	var and_ua = navigator.userAgent;
	if (and_ua.indexOf("Android") > 0) {
		var version = parseFloat(and_ua.slice(and_ua.indexOf("Android") + 8));
		return version;
	}
}

// -------------------------------------------------------------------
// htmlタグに以下のブラウザ判別用クラスを追加します
// -------------------------------------------------------------------
// https://kantaro-cgi.com/blog/javascript/add_class_every_browsers.html
// htmlタグに以下のブラウザ判別用クラスを追加します。
// 例えばIE6なら <html class="ie ie6"> となります。
// 対象：ie, chrome, firefox, oepra, sagari
// ※一応将来のバージョンにも対応してるのでIE99でも「class="ie ie99"」となります。
// ※ブラウザ名は全て小文字指定、バージョン指定の部分は、最初のマイナーバージョンまで、小数点の0のみはピリオドごと消える、「.」は「_」になる。
// 例：「Safari」→「safari」
// 例：「IE11.0」→「ie11」
// 例：「IE5.5」→「ie5_5」
// 例：「Safari5.1.7」→「safari5_1」

function addBrowserClass() {
	var __add = function(name, ver) {
		if (document.documentElement.className) {
			document.documentElement.className += ' ';
		}
		document.documentElement.className += name + (ver != '' ? ' ' + name + (ver * 1).toString().replace('.', '_') : '');
	}
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();
	if (get = userAgent.match(/msie (\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/Trident.+rv\:(\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/chrome\/(\d+(\.\d+)?)/i)) {
		__add('chrome', get[1]);
	} else if (get = userAgent.match(/firefox\/(\d+(\.\d+)?)/i)) {
		__add('firefox', get[1]);
	} else if (get = userAgent.match(/opera\/(\d+(\.\d+)?)/i)) {
		__add('opera', get[1]);
	} else if (get = userAgent.match(/safari\/(\d+(\.\d+)?)/i)) {
		__add('safari', get[1]);
	}

	// ついでにモバイルOS情報を付加する→ios(iphone, ipad, ipod), android
	if (get = userAgent.match(/iPhone OS (\d+(\.\d+)?)/i)) {
		__add('ios', get[1]);
	}
	if (get = userAgent.match(/iPhone;/i)) {
		__add('iphone', '');
	} else if (get = userAgent.match(/iPod;/i)) {
		__add('ipod', '');
	} else if (get = userAgent.match(/iPad;/i)) {
		__add('ipad', '');
	} else if (get = userAgent.match(/Android (\d+(\.\d+)?)/i)) {
		__add('android', get[1]);
	}
}
addBrowserClass();








var os, ua = navigator.userAgent;

if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "windows"; // windows 10 の処理 (windows Server 2016, windows Server 2019)
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "windows"; // windows 8.1 の処理 (windows Server 2012 R2)
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "windows"; // windows 8 の処理 (windows Server 2012)
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "windows"; // windows 7 の処理 (windows Server 2008 R2, windows Home Server 2011)
} else if (ua.match(/windows Phone/)) {
	os = "windowsphone"; // windows Phone (windows 10 Mobile) の処理


} else if (ua.match(/iPhone|iPad/)) {
	os = "ios"; // iOS (iPhone, iPod touch, iPad) の処理

} else if (ua.match(/Mac|PPC/)) {
	os = "macos"; // Macintosh の処理

} else if (ua.match(/Android ([\.\d]+)/)) {
	os = "android " + RegExp.$1; // Android の処理
} else if (ua.match(/Linux/)) {
	os = "linux"; // Linux の処理
} else if (ua.match(/^.*\s([A-Za-z]+BSD)/)) {
	os = RegExp.$1; // BSD 系の処理
} else if (ua.match(/SunOS/)) {
	os = "solaris"; // Solaris の処理
} else {
	os = "N/A"; // 上記以外 OS の処理
}
console.log(os);
$('html').addClass(os)
// document.write("あなたは " + os + " を使用されています。");

document.createElement("picture");

svg4everybody();

jQuery(function($) {
	objectFitImages('.object-fit');

	// $('.js-toggle_content__btn').on('click', function(event) {
	// 	event.preventDefault();
	// 	$(this).toggleClass('is-active');
	// 	console.log('obj');
	// 	$(this).parent().find('.js-toggle_content').slideToggle(400);
	// });


	// $(function() {
// Slider - Hero ===================================================
// setTimeout(function() {
// var swiperHero = new Swiper(".js-carusel--hero", {
// 	loop: true,
// 	effect: 'fade',
// 	speed: 2000,
//
// 	autoplay: {
// 		delay: 5000,
// 		disableOnInteraction: false,
// 	},
// 	fadeEffect: {
// 		crossFade: true
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		type: 'bullets',
// 	},
// });



var swiperSingle = new Swiper(".js-carouse_single", {
	spaceBetween: 0,
	slidesPerView: 1,
	// centeredSlides: true,
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".next-project",
		prevEl: ".prev-project",
	},
});

var swiperGalleyr = new Swiper(".js-gallery-slide", {
	spaceBetween: 0,
	slidesPerView: 1.5,
	// centeredSlides: true,
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
	breakpoints: {
		240: {
			slidesPerView: 1.5,
		},
		768: {
			slidesPerView: 1.5,
		},
		1024: {
			slidesPerView: 4,
		},
	},
});


var sliderThumbnailHero = new Swiper('.js-carusel--hero .js-carusel--box--thumbnail', {
	slidesPerView: 10000,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});

var itenNumsHero = $('.js-carusel--hero .swiper-slide:not(.swiper-slide-duplicate)').length;
for (var i = 0; i < itenNumsHero; i++) {
	sliderThumbnailHero.appendSlide('<li class="swiper-slide append"><button type="button"></button></li>');
}

var swiperHero = new Swiper(".js-carusel--hero", {
	loop: true,
	slidesPerView: 1,
	autoplay: {
		delay: 3600,
		// disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: 'fraction',
		renderFraction: function(currentClass, totalClass) {
			return '<span class="current ' + currentClass + '"></span>' +
				' <span class="counter-border"></span> ' +
				'<span class="total ' + totalClass + '"></span>';
		}
	},
	thumbs: {
		swiper: sliderThumbnailHero
	},
	// navigation: {
	// 	nextEl: ".swiper-button-next",
	// 	prevEl: ".swiper-button-prev",
	// },
	// breakpoints: {
	// 	240: {
	// 		slidesPerView: 1.1,
	// 	},
	// 	768: {
	// 		slidesPerView: 1.1,
	// 	},
	// 	1024: {
	// 		slidesPerView: 1.1,
	// 	},
	// },
	on: {
		init: function() {
			// 任意の処理を実行
			// $('.js-carusel--hero .title').tile();
		}
	}
});
// }, 2000);
//
//




// var swiperEntry = new Swiper(".js-carusel--entry", {
// 	loop: true,
// 	speed: 800,
// 	slidesPerView: 3,
// 	spaceBetween: 30,
// 	autoplay: {
// 		delay: 3600,
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true
// 	},
// });


// var swiperGallery = new Swiper(".js-carusel--gallery", {
// 	loop: true,
// 	speed: 800,
// 	spaceBetween: 2,
// 	autoplay: {
// 		delay: 3600,
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true
// 	},
// });

//
// var SwiperTop = new Swiper('.js-shoplist', {
// 	spaceBetween: 0,
// 	centeredSlides: true,
// 	speed: 6000,
// 	autoplay: {
// 		delay: 1,
// 	},
// 	loop: true,
// 	slidesPerView: 'auto',
// 	allowTouchMove: false,
// 	disableOnInteraction: true
// });

	// $(function() {

$('#js-navi__toggle').on('click', function(event) {
	$('html').toggleClass('is-navi-active');
	$('.menu_trigger').toggleClass('is-active');
	$(this).toggleClass('is-navi-active');
	// $('#js-header').toggleClass('is-active');
	$('#js-navi-global').toggleClass('is-active');
	$('html').toggleClass('is-lock');

	if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
		togglemodal()
	}
});


$('#js-navi-global a').on('click', function(event) {
	setTimeout(function() {
		$('html').removeClass('is-navi-active');
		$('.menu_trigger').removeClass('is-active');
		$('#js-navi__toggle').removeClass('is-navi-active');
		// $('#js-header').removeClass('is-active');
		// $('#js-drawer-navi').removeClass('is-active');
		$('#js-navi-global').toggleClass('is-active');

		$('html').removeClass('is-lock');
	}, 600);
	// }
	if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
		togglemodal()
	}
});

// });

//ios modal 背景ロック
function togglemodal() {
	if (!document.body.classList.contains('navi_active')) {
		document.body.classList.add('navi_active');

		var elem = document.getElementById('js-navi');
		elem.addEventListener('touchmove', function(e) {
			var scroll = elem.scrollTop;
			var range = elem.scrollHeight - elem.offsetHeight - 1;
			if (scroll < 1) {
				e.preventDefault();
				elem.scrollTop = 1;
			} else if (scroll > range) {
				e.preventDefault();
				elem.scrollTop = range;
			}
		});

	} else {
		document.body.classList.remove('navi_active');
	}
}

	// click時位置補正
$('#js-navi-traking li a').on('click', function(event02) {
	setTimeout($.proxy(function(event02) {
		// console.log('go');
		$('#js-navi-traking li').removeClass('is-current');
		$(this).parent().addClass('is-current');
	}, this), 500);
	setTimeout($.proxy(function(event02) {
		// console.log('go');
		$('#js-navi-traking li').removeClass('is-current');
		$(this).parent().addClass('is-current');
	}, this), 1000);
});

function targetCu() {
	var margin = 68, //ウインドウ上部からどれぐらいの位置で変化させるか
		sectionTop = new Array, //sectionのTop位置格納用
		current = -1; //現在のカレント位置
	//(1)各targetの縦位置を取得
	$('.js-navi-position').each(function(i) {
		sectionTop[i] = $(this).offset().top;
	});
	//init
	changeNavCurrent(0);
	//スクロールした時の処理
	$(window).scroll(function() {
		scrollY = $(window).scrollTop();
		//(2)各targetの位置とスクロール位置を比較して、条件にあったらchangeNavCurrentを実行
		for (var i = sectionTop.length - 1; i >= 0; i--) {
			if (scrollY > sectionTop[i] - margin) {
				changeNavCurrent(i);
				break;
			}
		};
	});
	//(3)ナビの処理
	function changeNavCurrent(curNum) {
		if (curNum != current) {
			current = curNum;
			curNum2 = curNum + 1; //HTML順序用
			$('#js-navi-traking li').removeClass('is-current');
			$('#js-navi-traking li:nth-child(' + curNum2 + ')').addClass('is-current');
		}
	};
}
//ファンクション実行
$(window).on('load', function() {
	targetCu();
});

var timer = false;
//リサイズ時ファンクション再実行
$(window).resize(function() {
	if (timer !== false) {
		clearTimeout(timer);
	}
	timer = setTimeout(function() {
		console.log('resized');
		targetCu();
	}, 200);

});



//
// function targetCu() {
//
// 	var margin = 68,
// 		sectionTop = new Array,
// 		current = -1;
// 	$('.js-navi-position').each(function(i) {
// 		sectionTop[i] = $(this).offset().top;
// 	});
// 	changeNavCurrent(1);
// 	$(window).on('scroll', function() {
// 		scrollY = $(window).scrollTop();
// 		for (var i = sectionTop.length - 1; i >= 0; i--) {
// 			if (scrollY > sectionTop[i] - margin) {
// 				changeNavCurrent(i);
// 				break;
// 			}
// 		};
// 	});
//
// 	function changeNavCurrent(curNum) {
// 		if (curNum != current) {
// 			current = curNum;
// 			curNum2 = curNum + 0;
// 			$('#js-navi-traking li').removeClass('is-current');
// 			$('#js-navi-traking li:nth-child(' + curNum2 + ')').addClass('is-current');
// 		}
// 	};
// }
//
// $(window).on('load', function() {
// 	// $('body,html').stop().animate({
// 	// 	scrollTop: 100
// 	// }, 100);
// 	targetCu();
// })
//
//
//
// var timer = false;
// //リサイズ時ファンクション再実行
// $(window).on('resize', function() {
// 	if (timer !== false) {
// 		clearTimeout(timer);
// 	}
// 	timer = setTimeout(function() {
// 		// console.log('resized');
// 		targetCu();
// 	}, 200);
// });

	$(window).on('load resize', function() {

	var wtile = $(window).width();
	var xtile = 641;

	if (xtile <= wtile) {
		$('.js-tile01__pc').tile();
		$('.js-tile02__pc').tile();
		$('.js-tile03__pc').tile();
		$('.js-tile04__pc').tile();
		$('.js-tile05__pc').tile();
	} else if (wtile <= xtile) {
		$('.js-tile01__sp').tile();
		$('.js-tile02__sp').tile();
		$('.js-tile03__sp').tile();
		$('.js-tile04__sp').tile();
		$('.js-tile05__sp').tile();
	}
	$('.js-tile').tile();
	$('.js-tile01').tile();
	$('.js-tile02').tile();
	$('.js-tile03').tile();
	$('.js-tile04').tile();
	$('.js-tile05').tile();
});
//project =========
// $('.recommend .c-content .c-item dl dt').tile();
// $('.recommend .c-content .c-item dl dd').tile();


		/* ======================================
	smooth scroll
	====================================== */
	// #で始まるアンカーをクリックした場合に処理
	// $('a[href^="#"]').on('click', function() {
	// 	var speed = 400; // ミリ秒で記述
	// 	var href = $(this).attr("href");
	// 	var target = $(href == "#" || href == "" ? 'html' : href);
	// 	var position = target.offset().top;
	// 	$('body,html').animate({
	// 		scrollTop: position
	// 	}, speed, 'swing');
	// 	return false;
	// });
	// var headerHeight = $('.header').outerHeight();
	headerHeight = 68;
	var urlHash = location.hash;
	if (urlHash) {
		$(window).on('load', function() {
			$('body,html').stop().scrollTop(0);
			setTimeout(function() {
				var target = $(urlHash);
				// var position = target.offset().top;
				var position = target.offset().top - headerHeight;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
		});
	}
	$('a[href^="#"]').click(function() {
		var href = $(this).attr("href");
		var target = $(href);
		// var position = target.offset().top;
		var position = target.offset().top - headerHeight;
		$('body,html').stop().animate({
			scrollTop: position
		}, 500);
	});

	$(function() {

	$('.wp').waypoint(function(direction) {
		var thisWP = $(this.element);
		if (direction === 'down') {
			thisWP.addClass('is-wp-active');
		} else {}
		// thisWP.removeClass('is-wp-active');
	}, {
		offset: '80%'
	});

	$('.wp-fig').waypoint(function(direction) {
		var thisWP = $(this.element);
		if (direction === 'down') {
			thisWP.addClass('is-wp-fig-active');
		} else {}
		// thisWP.removeClass('is-wp-active');
	}, {
		offset: '80%'
	});

});
//
$(window).one('load', function() {
	// console.log('obj');
	// $('.wp').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-active');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });
	//
	// $('.wp-fig').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-fig-active');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });



	//
	// $('#service01').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		$('.c-service-flow .is-red').addClass('is-active');
	// 	} else {}
	// 	// $('.c-service-flow .is-red').removeClass('is-active');
	// }, {
	// 	offset: '100%'
	// });
	// $('#service02').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		$('.c-service-flow .is-yellow').addClass('is-active');
	// 	} else {}
	// 	// $('.c-service-flow .is-red').removeClass('is-active');
	// }, {
	// 	offset: '100%'
	// });

});

});

$(window).on('load', function() {
	$('html').addClass('is-loaded');
});
